<template>
    <v-dialog v-model="dialog" width="1200" content-class="dialog-sobre">
        <v-card style="overflow-x: scroll;">
            <v-list >
                <v-list-item style="display: flex; width: 100%; justify-content: end; padding: 20px 25px 0px 25px;" >
                    <v-list-item-title style="font-size: 18px; font-weight: bold;">Criar Movimentação de Estoque</v-list-item-title>
                    <v-btn 
                        @click="$emit('close')"
                        style="display: flex; background-color: transparent; justify-self: center; margin-right: 12px;"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn 
                        @click="validateAndProceed" 
                        style="display: flex; background-color: blue; align-self: end; justify-self: end; margin-bottom: 6px; color: white !important;"
                    >
                        Salvar <v-icon style="margin-left: 4px;">mdi-check</v-icon>
                    </v-btn>
                </v-list-item>
            </v-list>

            <v-form ref="form" v-model="isFormValid">
                <v-list style="display: flex; padding: 12px; flex-direction: row; flex-wrap: wrap; gap: 18px;">

                    <v-autocomplete
                        v-model="payload.origem"
                        :items="localOptions"
                        item-text="text"
                        item-value="id"
                        label="Origem"
                        dense
                        outlined
                        :rules="[rules.required]"
                    ></v-autocomplete>

                    <v-autocomplete
                        v-model="payload.item"
                        :items="itemOptions"
                        item-text="text"
                        item-value="id"
                        label="Item"
                        :rules="[rules.required]"
                        :disabled="!payload.origem"
                        dense
                        outlined
                    ></v-autocomplete>               
                    
                    <v-text-field 
                        label="Quantidade" 
                        type="number" 
                        v-model="payload.quantidade" 
                        dense 
                        outlined
                        :rules="[rules.required, rules.min, rules.max]"
                        :hint="'Quantidade disponível na origem: ' + quantidadeMaxima"
                    ></v-text-field>

                    <v-autocomplete
                        v-model="payload.tipoOperacao"
                        :items="tipoOperacaoOptions"
                        item-text="text"
                        item-value="id"
                        label="Tipo de Operação"
                        dense
                        outlined
                        :rules="[rules.required]"
                    ></v-autocomplete>

                    <v-autocomplete
                        v-model="payload.destino"
                        :items="localOptions"
                        item-text="text"
                        item-value="id"
                        label="Destino"
                        dense
                        outlined
                        :rules="[rules.required]"
                    ></v-autocomplete>    
                </v-list>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';

export default {
    props: {
        value: Boolean,
        codigo: String,
        refreshMovimentacaoDeEstoque: Function
    },
    data() {
        return {
            e1: 1,
            isFormValid: false,
            isTypeValid: true,
            itemOptions: [],
            tipoOperacaoOptions: [],
            localOptions: [],
            quantidadeMaxima: 0,
            modalOpen: false,
            user: {},
            rules: {
                required: v => !!v || "Campo obrigatório",
                min: v => v >= 0 || "Valor não pode ser negativo",
                max: v => v <= this.quantidadeMaxima || `Máximo permitido é ${this.quantidadeMaxima > 0 ? this.quantidadeMaxima : 0}`
            },
            payload: this.getInitialPayload(),
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val); // Emite evento para atualizar o estado do modal
            }
        },
        themeClass() {
            return this.$vuetify.theme.dark ? 'dark-theme' : 'light-theme';
        },
    },
    methods: {

      async getTenanty(){
        const lc = window.localStorage.getItem("UsuarioStore");
        const user = JSON.parse(lc);

        const req = await Vue.prototype.$http.get(`/Entity/Collaborator/search-fields?value=${user.id}&companySiteId=userId`)
        this.user = req.data.data.data[0]
      },

        getInitialPayload() {
            return {
                codigo: '',
                item: '',
                quantidade: '',
                origem: '',
                destino: '',
                tipoOperacao: ''
            }
        },

        async validateAndProceed() {
            if (this.$refs.form.validate()) {
                try {
                    const tipoOperacao = this.tipoOperacaoOptions.find(oper => oper.id === this.payload.tipoOperacao)?.type;
                    const localEstoqueOrigemDescricao = this.localOptions.find(local => local.id === this.payload.origem)?.text;
                    const localEstoqueDestinoDescricao = this.localOptions.find(local => local.id === this.payload.destino)?.text;

                    const reqOrigem = await Vue.prototype.$http.get(
                        `/Entity/StockBalance/search-fields?value=[${this.payload.item}],[${this.payload.origem}]&searchFields=[item],[localEstoque]`
                    );

                    const reqDestino = await Vue.prototype.$http.get(
                        `/Entity/StockBalance/search-fields?value=[${this.payload.item}],[${this.payload.destino}]&searchFields=[item],[localEstoque]`
                    );

                    const origemData = reqOrigem.data.data.data[0];
                    const destinoData = reqDestino.data.data.data[0];

                    const origemExists = reqOrigem.data.data.total > 0;
                    const destinoExists = reqDestino.data.data.total > 0;

                    const cleanOrigem = origemExists
                        ? (({ updateAt, updateBy, deleteAt, deleteBy, isDeleted, ...rest }) => rest)(origemData)
                        : null;

                    const cleanDestino = destinoExists
                        ? (({ updateAt, updateBy, deleteAt, deleteBy, isDeleted, ...rest }) => rest)(destinoData)
                        : null;

                    if (origemExists && destinoExists) {

                        await Vue.prototype.$http.put(`/Entity/StockBalance`, {
                            ...cleanOrigem,
                            quantidadeTotal: Number(cleanOrigem.quantidadeTotal - this.payload.quantidade),
                            quantidadeDisponivel: Number(cleanOrigem.quantidadeDisponivel - this.payload.quantidade),
                            valorTotal: cleanOrigem.valorMedio ? Number(Number(cleanOrigem.valorTotal) - Number(Number(cleanOrigem.valorMedio) * Number(this.payload.quantidade))) : 0
                        });

                        const newCodigoHistoricoOrigem = await Vue.prototype.$http.get(
                            "/Entity/AutoInc?schemaName=HistoricoMovimentacaoItem&field=codigo&mask=######"
                        );

                        await Vue.prototype.$http.post(`/Entity/HistoricoMovimentacaoItem`, {
                            "codigo": newCodigoHistoricoOrigem.data,
                            "tipo": 'Saída',
                            "descricao": `TRANSFERÊNCIA DE ESTOQUE DE ${localEstoqueOrigemDescricao} PARA ${localEstoqueDestinoDescricao}`,
                            "dataMovimentacao": moment().format("YYYY-MM-DD"),
                            "quantidade": Number(this.payload.quantidade),
                            "colaboradorDaMovimentacao": this.user.id, 
                            "saldoDeEstoque": cleanOrigem.id,
                            "item": this.payload.item,
                            "PISValor": cleanOrigem.PISValor,
                            "COFINSValor": cleanOrigem.COFINSValor,
                            "ICMSValor": cleanOrigem.ICMSValor
                        });

                        await Vue.prototype.$http.put(`/Entity/StockBalance`, {
                            ...cleanDestino,
                            quantidadeTotal: Number(cleanDestino.quantidadeTotal + this.payload.quantidade),
                            quantidadeDisponivel: Number(cleanDestino.quantidadeDisponivel + this.payload.quantidade),
                            valorTotal: cleanOrigem.valorMedio ? Number(cleanDestino.valorTotal + (cleanOrigem.valorMedio * this.payload.quantidade)) : 0,
                            valorMedio: cleanOrigem.valorMedio ? Number(Number(Number(cleanDestino.quantidadeTotal) + Number(this.payload.quantidade)) / Number(Number(cleanDestino.valorTotal) + Number(Number(cleanOrigem.valorMedio) * Number(this.payload.quantidade)))) : 0,
                            PISValor: cleanOrigem.PISValor,
                            COFINSValor: cleanOrigem.COFINSValor,
                            ICMSValor: cleanOrigem.ICMSValor
                        });

                        const newCodigoHistoricoDestino = await Vue.prototype.$http.get(
                            "/Entity/AutoInc?schemaName=HistoricoMovimentacaoItem&field=codigo&mask=######"
                        );

                        await Vue.prototype.$http.post(`/Entity/HistoricoMovimentacaoItem`, {
                            "codigo": newCodigoHistoricoDestino.data,
                            "tipo": 'Entrada',
                            "descricao": `TRANSFERÊNCIA DE ESTOQUE DE ${localEstoqueOrigemDescricao} PARA ${localEstoqueDestinoDescricao}`,
                            "dataMovimentacao": moment().format("YYYY-MM-DD"),
                            "quantidade": Number(this.payload.quantidade),
                            "colaboradorDaMovimentacao": this.user.id,
                            "saldoDeEstoque": cleanDestino.id,
                            "item": this.payload.item,
                            "PISValor": cleanOrigem.PISValor,
                            "COFINSValor": cleanOrigem.COFINSValor,
                            "ICMSValor": cleanOrigem.ICMSValor
                        });

                    } else {

                        console.log(cleanOrigem.valorMedio,cleanOrigem.valorTotal)

                        await Vue.prototype.$http.put(`/Entity/StockBalance`, {
                            ...cleanOrigem,
                            quantidadeTotal: Number(cleanOrigem.quantidadeTotal - this.payload.quantidade),
                            quantidadeDisponivel: Number(cleanOrigem.quantidadeDisponivel - this.payload.quantidade) ?? 0,
                            valorTotal: cleanOrigem.valorMedio ? Number(Number(cleanOrigem.valorTotal) - Number(Number(cleanOrigem.valorMedio) * Number(this.payload.quantidade))) : 0
                        });

                        const newCodigoHistoricoOrigem = await Vue.prototype.$http.get(
                            "/Entity/AutoInc?schemaName=HistoricoMovimentacaoItem&field=codigo&mask=######"
                        );

                        await Vue.prototype.$http.post(`/Entity/HistoricoMovimentacaoItem`, {
                            "codigo": newCodigoHistoricoOrigem.data,
                            "tipo": 'Saída',
                            "descricao": `TRANSFERÊNCIA DE ESTOQUE DE ${localEstoqueOrigemDescricao} PARA ${localEstoqueDestinoDescricao}`,
                            "dataMovimentacao": moment().format("YYYY-MM-DD"),
                            "quantidade": Number(this.payload.quantidade),
                            "colaboradorDaMovimentacao": this.user.id,
                            "saldoDeEstoque": cleanOrigem.id,
                            "item": this.payload.item,
                            "PISValor": cleanOrigem.PISValor,
                            "COFINSValor": cleanOrigem.COFINSValor,
                            "ICMSValor": cleanOrigem.ICMSValor
                        });

                        const newCodigo = await Vue.prototype.$http.get(
                            "/Entity/AutoInc?schemaName=StockBalance&field=codigo&mask=######"
                        );

                        const newOrigem = await Vue.prototype.$http.post(`/Entity/StockBalance`, {
                            codigo: newCodigo.data,
                            item: this.payload.item,
                            localEstoque: this.payload.destino,
                            quantidadeTotal: Number(this.payload.quantidade),
                            quantidadeDisponivel: Number(this.payload.quantidade),
                            valorTotal: cleanOrigem.valorMedio ? Number(Number(cleanOrigem.valorMedio) * Number(this.payload.quantidade)) : 0,
                            valorMedio: cleanOrigem.valorMedio ? Number(Number(this.payload.quantidade) / Number((Number(cleanOrigem.valorMedio) * Number(this.payload.quantidade)))) : 0,
                            quantidadeReservado: 0,
                            PISValor: cleanOrigem.PISValor,
                            COFINSValor: cleanOrigem.COFINSValor,
                            ICMSValor: cleanOrigem.ICMSValor
                        });

                        const newCodigoHistoricoDestino = await Vue.prototype.$http.get(
                            "/Entity/AutoInc?schemaName=HistoricoMovimentacaoItem&field=codigo&mask=######"
                        );

                        await Vue.prototype.$http.post(`/Entity/HistoricoMovimentacaoItem`, {
                            "codigo": newCodigoHistoricoDestino.data,
                            "tipo": 'Entrada',
                            "descricao": `TRANSFERÊNCIA DE ESTOQUE DE ${localEstoqueOrigemDescricao} PARA ${localEstoqueDestinoDescricao}`,
                            "dataMovimentacao": moment().format("YYYY-MM-DD"),
                            "quantidade": Number(this.payload.quantidade),
                            "colaboradorDaMovimentacao": this.user.id,
                            "saldoDeEstoque": newOrigem.data.data.id,
                            "item": this.payload.item,
                            "PISValor": cleanOrigem.PISValor,
                            "COFINSValor": cleanOrigem.COFINSValor,
                            "ICMSValor": cleanOrigem.ICMSValor
                        });

                    }

                    await Vue.prototype.$http.post(`/Entity/StockMov`, {
                        ...this.payload,
                        codigo: this.codigo,
                        quantidade: Number(this.payload.quantidade),
                    });

                    this.resetPayload();
                    this.$emit("close");
                    this.refreshMovimentacaoDeEstoque();

                } catch (error) {
                    console.error("Erro ao cadastrar movimentação de estoque:", error);
                }
            } else {
                console.log("Formulário inválido!");
            }
        },

        resetPayload() {
            this.payload = this.getInitialPayload();
            this.isTypeValid = false;
            this.images = [];
        },

        setModalOpen() {
            this.modalOpen = !this.modalOpen;
        },

        async getItemRelationOptions() {

            let reqItem = await Vue.prototype.$http.get(
                `/Entity/StockBalance/search-fields?value=${this.payload.origem}&searchFields=localEstoque`
            );
            let item = reqItem.data.data.data

            this.itemOptions = [
                ...new Map(
                    item
                    .filter(i => i.item && i.itemDescricao)
                    .map(i => [i.item, { text: i.itemDescricao, id: i.item }])
                ).values()
            ].sort((a, b) => (a.text || '').localeCompare(b.text || ''));

        },

        // GET de todos pedidos de compra para autocomplete
        async getAllRelationOptions() {
            try {

                let reqTipoOperacao = await Vue.prototype.$http.get('/Entity/StockOperationType/search-fields', {
                params: {
                    value: 'Transferência',
                    limit: 99999,
                    searchFields: 'tipo'
                }
                });
                let tipoOperacao = reqTipoOperacao.data.data.data

                let reqLocal = await Vue.prototype.$http.get(`/Entity/StockLocal?limit=99999`);
                let local = reqLocal.data.data.data

                this.tipoOperacaoOptions = [
                ...new Map(
                    tipoOperacao.map(oper => [oper.id, { text: oper.descricao, id: oper.id, type: oper.tipo }])
                ).values()
                ].sort((a, b) => a.text.localeCompare(b.text));

                this.localOptions = [
                ...new Map(
                    local.map(locale => [locale.id, { text: locale.descricao, id: locale.id }])
                ).values()
                ].sort((a, b) => a.text.localeCompare(b.text));

            } catch (error) {
                console.error("Erro ao buscar fornecedores:", error);
            }
        },

        async getAvailableQuantity() {
            try {
                if (this.payload.item && this.payload.origem) {

                    const res = await Vue.prototype.$http.get(
                        `/Entity/StockBalance/search-fields?value=[${this.payload.item}],[${this.payload.origem}]&searchFields=[item],[localEstoque]`
                    );

                    const result = res.data.data.data[0];

                    if (result) {

                        this.quantidadeMaxima = result.quantidadeDisponivel || 0;

                        this.rules.max = v => v <= this.quantidadeMaxima || `Máximo permitido é ${this.quantidadeMaxima > 0 ? this.quantidadeMaxima : 0}`;

                    } else {
                        this.quantidadeMaxima = 0;
                    }

                }
            } catch (e) {
                console.error('Erro ao buscar quantidade disponível: ', e);
                this.quantidadeMaxima = 0;
            }
        }
    },
    watch: {
        value(val) {
            if (val) {
                this.$nextTick(() => {
                    if (this.$refs.form) {
                        this.$refs.form.resetValidation();
                    }
                });
            }
        },
        'payload.item'(val) {
            this.getAvailableQuantity();
        },
        'payload.origem'(val) {
            this.getItemRelationOptions();
            this.getAvailableQuantity();
        }
    },
    created() {
        this.getAllRelationOptions();
        this.getTenanty();
    }
};
</script>
  
<style scoped>

    .style-i {
        color: white;
        font-size: 22px;
    }
    /*
    .style-i:hover {
        color: white;
    }*/

    .item-content {
        border-bottom: 1px solid rgba(172, 168, 168, 0.719);
    }

    a {
        color: black;
        margin-left: 5px;
        color: black;
    }


    span {
        float: right;
        font-size: 10px;
    }
    .card-item{
        position: relative;
    }

    .card-item:hover {
        cursor: pointer;
        background-color: whitesmoke;
    }

    .btn-aprovar, .btn-enviar-obs {
        background-color: green;
        border-radius: 15px;
        padding: 6px;
        color: white;
        font-size: 12px;
        margin: 0px 8px;
    }

    .btn-aprovar:hover, .btn-enviar-obs:hover {
        background-color: white;
        border: 1px solid green;
        color: green;
    }

    .btn-reprovar, .btn-cancelar-obs {
        background-color: red;
        border-radius: 15px;
        padding: 6px;
        color: white;
        font-size: 12px;
        margin: 0px 8px;
    }

    .btn-reprovar:hover, .btn-cancelar-obs:hover {
        background-color: white;
        border: 1px solid red;
        color: red;
    }

    .obs-container {
        margin-top: 3px;
        border: 1px solid #c5c0c0;
        padding: 5px;
    }

    .span-enviado {
        position: absolute;
        right: 15px;
        bottom: 2px;
    }

    .v-list-item__content{
        padding: 0px;
        max-height: 75px;
    }

  .img {
    margin: auto;
  }
  
  .card {
    margin-left: 500px;
  }
  
  .v-btn {
    margin-top: 15px;
  }
  
  .dialog-sobre {
    width: 500px !important;
  }
  
  .v-dialog__content {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 6;
    outline: none;
  }

  .checkbox {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  
  .v-text-field--outlined fieldset {
    border: 0;
    border-bottom: 1px solid black;
    border-radius: 0;;
  }

  .v-text-field--outlined .v-text-field__slot {
    align-items: end !important;
  }

  .v-text-field .v-input__slot {
    padding: 0 !important;
  }

  .filterInputDate {
    outline: none;
    border: 1px solid #666;
    border-radius: 4px;
    width: 269px;
    padding-left: 10px;
    font-size: 12px;
    height: 40px;
  }

  .filterInput {
    width: 30%;
    text-decoration: none !important;
    border: none !important;
  }

  .theme--dark.v-list {
    background-color: #1e1e1e;
  }

  .v-sheet.v-stepper {
    border-radius: 0px;
  }

  .theme--dark.v-card {
    background-color: #1e1e1e;
  }

  .v-data-table-header {
    border-radius: 12px;
  }

  .v-btn[data-v-4b1b6f7c] {
    margin-top: 0px;
  }
  
  .v-stepper__header {
    box-shadow: none !important;
  }

  .v-stepper__content {
    padding: 0px 24px 16px 24px;
  }

  .theme--dark.tabsBg{
    background-color: #1e1e1e !important;
  }

  .checkbox-label ::v-deep(.v-label) {
    font-size: 16px; /* Aumente o tamanho conforme necessário */
    /* font-weight: bold; Opcional: deixa a fonte mais destacada */
    }
</style>
  